import { Avatar, Box, Typography } from '@material-ui/core'
import 'moment/locale/pt-br'
import ExpandableCard from '../../components/expandable-card'
import { stringAvatar } from '../../utils/functions'

export const ProcessClient = ({ client, ...props }) => {

    return (
        <ExpandableCard realce={true} title={`Cliente`}>

            <Box style={{ display: 'flex', padding: '16px', marginBottom: '16px', alignItems: 'center' }}>
                <Avatar variant={'circle'} {...stringAvatar(client?.name || "")} />
                <Box style={{ marginInline: '16px' }}>
                    <Typography variant="h6">{client?.name}</Typography>
                    {client.no_contact_info ?
                        (
                            <Typography variant="body2" color="textSecondary">
                                {"Contato não informado."}
                            </Typography>
                        ) : (
                            <Box>
                                <Typography variant="body2" color="textSecondary">
                                    {client?.email}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {client?.phone}
                                </Typography>
                            </Box>
                        )
                    }
                </Box>
            </Box>
        </ExpandableCard>
    )
}